import { NgModule, Type } from '@angular/core';
import { MatLegacyAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyNativeDateModule, MatLegacyOptionModule } from '@angular/material/legacy-core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySliderModule } from '@angular/material/legacy-slider';
import { MatLegacySnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';

const components: Type<any>[] = [
  MatLegacyAutocompleteModule,
  MatLegacyButtonModule,
  MatLegacyCardModule,
  MatLegacyCheckboxModule,
  MatLegacyChipsModule,
  MatLegacyNativeDateModule,
  MatLegacyOptionModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatLegacyDialogModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatLegacyInputModule,
  MatLegacyListModule,
  MatLegacyMenuModule,
  MatLegacyPaginatorModule,
  MatLegacyProgressBarModule,
  MatLegacyProgressSpinnerModule,
  MatLegacyRadioModule,
  MatLegacySelectModule,
  MatSidenavModule,
  MatLegacySlideToggleModule,
  MatLegacySliderModule,
  MatLegacySnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatLegacyTableModule,
  MatLegacyTabsModule,
  MatToolbarModule,
  MatLegacyTooltipModule,
  MatButtonToggleModule,
];

@NgModule({
  providers: [],
  imports: [components],
  exports: [components],
})
export class AppMaterialModule {}
